module.exports = "<app-export-templates [template]=\"template\"></app-export-templates>"